import {
    USER_LOGOUT, FETCH_ADMIN_SUBSCRIPTIONS,DELETE_ADMIN_SUBSCRIPTION,ADD_ADMIN_SUBSCRIPTION,
      UPDATE_ADMIN_SUBSCRIPTION  }  from "actions/actionTypes";

var _ = require('lodash');

const initialState = {data: [], fetched:false, total:0 };
export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_ADMIN_SUBSCRIPTIONS:
            console.log('in FETCH_ADMIN_SUBSCRIPTIONS',action.payload );
             return {
                ...state,
                data: action.payload.data,
                total: action.payload.total,
                 fetched:true,
            }
        case ADD_ADMIN_SUBSCRIPTION:
         //   console.log('ADD_ADMIN_SUBSCRIPTION', state, action.payload);

            return {
                ...state,
                data: _.concat(state.data, [action.payload]),
                 total:state.total+1,
            }
        case UPDATE_ADMIN_SUBSCRIPTION:
            console.log('UPDATE_ADMIN_SUBSCRIPTION', state,  action.payload);
            var itemProductIndex = _.findIndex(state.data, {'_id': action.payload._id});

            var updatedProducts = [...state.data.slice(0, itemProductIndex),
                action.payload,
                ...state.data.slice(itemProductIndex + 1)];
            return {
                ...state,
                data: updatedProducts
            }

        case DELETE_ADMIN_SUBSCRIPTION:
            console.log('DELETE_ADMIN_SUBSCRIPTION', action.payload);
            var itemProductIndex = _.findIndex(state.data, {'_id': action.payload.recordID});
            var updatedProducts = [...state.data.slice(0, itemProductIndex),
                ...state.data.slice(itemProductIndex + 1)];
            return {
                ...state,
                total:state.total-1,
                data: updatedProducts
            }

        case USER_LOGOUT:
            return initialState;
        default:
            return state;
    }
}

export const getRecord = (state, id) => {
     return state.adminSubscriptions.data.filter(record => record._id === id)[0];
}